"use client";

import { isTemplateActive, type FeatureName } from "@/services/template.service";
import { useAdminFeaturesExist } from "@/hooks/auth/use-admin-features-exist";

/**
 * Whether an opt-in (or required) feature is active for the current tenant.
 * A feature is "active" once its entity exists in `entityList` with all required
 * fields/relations — see `isTemplateActive`. The `feature` key is type-checked
 * against the template list, so only real feature names are accepted.
 *
 * @example
 *   const dashboardsEnabled = useIsFeatureActive("Dashboard");
 */
export const useIsFeatureActive = (feature: FeatureName): boolean => {
  const { adminExists } = useAdminFeaturesExist();
  return isTemplateActive(adminExists?.templateResults?.[feature]);
};
